<template>
    <div>
        <v-row no-gutters>
            <v-col cols="6">
                <h1 class="headline font-weight-light mb-3">
                    Performance
                </h1>
            </v-col>
            <v-col cols="6" class="text-right">
                <v-btn
                    rounded
                    class="ml-2"
                    color="amber"
                    small
                    v-if="team_name == 'ONSITE' || team_name == 'NONHP'"
                    @click="
                        ;(date = new Date().toISOString().substr(0, 10)),
                            get_zonehistory(1),
                            (dialoghistory = true),
                            (form_searchhistory.emp_id = '')
                    "
                >
                    <v-icon small class="mr-1">mdi-history</v-icon>
                    history
                </v-btn>
            </v-col>
        </v-row>

        <div class="mar-t-10">
            <v-row>
                <v-col cols="8" sm="6" md="3">
                    <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="dateRangeText"
                                label="Date range"
                                readonly
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="dates"
                            range
                            @change="get_date()"
                        ></v-date-picker>
                    </v-menu>
                </v-col>

                <!-- <v-col cols="1" class="mt-4">
                    <v-btn
                        x-small
                        fab
                        class="mr-1"
                        @click="reset()"
                        v-if="dateRangeText != ''"
                    >
                        <v-icon>mdi-rotate-left</v-icon></v-btn
                    >
                </v-col> -->
            </v-row>
        </div>

        <div class="no-pd mar-t-20" v-if="data_main.length > 0">
            <v-row>
                <v-col cols="12">
                    <v-simple-table class="table-inv">
                        <template v-slot:default>
                            <thead>
                                <tr class="col-tr-1">
                                    <th class="text-center">#</th>
                                    <th class="text-center">
                                        Date
                                    </th>

                                    <th class="text-center">
                                        CaseID
                                    </th>
                                    <th class="text-center">Project</th>
                                    <th class="text-center">Site Name</th>
                                    <th class="text-center">Solution</th>
                                    <th class="text-center">
                                        GPS
                                    </th>
                                    <th class="text-center">
                                        Status
                                    </th>
                                    <th class="text-center">
                                        E-CSO
                                    </th>
                                    <th class="text-center">
                                        ISmart
                                    </th>
                                    <th class="text-center">Cso</th>
                                    <th class="text-center">Attact</th>
                                    <th class="text-center">Uefi</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(row, index) in data_main"
                                    :key="index"
                                >
                                    <td class="text-center">
                                        {{ index + 1 }}.
                                    </td>
                                    <td class="text-center">
                                        {{ row.onsite_at }} <br />
                                        <v-chip x-small>{{
                                            row.start + " - " + row.stop
                                        }}</v-chip>
                                    </td>
                                    <td>
                                        {{ row.case_id }}
                                    </td>
                                    <td>
                                        {{ row.project_name }}
                                    </td>
                                    <td>
                                        {{ row.site_name }}
                                    </td>
                                    <td>
                                        <span
                                            class="cur-p"
                                            style="color:#018049;"
                                            @click="change_solotion(row)"
                                        >
                                            {{ row.solution }}
                                        </span>
                                    </td>
                                    <td class="text-center">
                                        {{ row.gps_at }}
                                    </td>

                                    <td class="text-center">
                                        {{ row.sub_status_name }}
                                    </td>
                                    <td class="text-center">
                                        <v-btn
                                            fab
                                            x-small
                                            color="amber"
                                            v-if="row.e_cso == 'Y'"
                                        >
                                            <v-icon
                                                class="primary--text"
                                                @click="
                                                    view_e_cso(
                                                        row.subcase_id,
                                                        row.show_rate,
                                                        row.show_sign,
                                                        row.email
                                                    )
                                                "
                                            >
                                                mdi-magnify
                                            </v-icon>
                                        </v-btn>
                                    </td>
                                    <td class="text-center">
                                        <v-btn
                                            fab
                                            x-small
                                            color="amber"
                                            v-if="row.show_ismart == 'Y'"
                                        >
                                            <v-icon
                                                class="primary--text"
                                                @click="
                                                    view_ismart(row.subcase_id)
                                                "
                                            >
                                                mdi-magnify
                                            </v-icon>
                                        </v-btn>
                                    </td>
                                    <td class="text-center">
                                        <v-badge
                                            avatar
                                            bordered
                                            overlap
                                            style="margin-top:11px;"
                                            v-if="
                                                row.project_name != 'Return' &&
                                                    row.project_name !=
                                                        'Return-Pickup' &&
                                                    row.show_upload == 'Y'
                                            "
                                        >
                                            <template v-slot:badge>
                                                <v-avatar
                                                    :color="
                                                        row.cso.length == 0
                                                            ? 'grey'
                                                            : 'light-blue darken-2'
                                                    "
                                                >
                                                    {{ row.cso.length }}
                                                </v-avatar>
                                            </template>

                                            <v-avatar
                                                class="
                                                    fix-avatar-per cur-p
                                                "
                                                @click="
                                                    change_img(
                                                        row.cso,
                                                        'cso',
                                                        row.maincase_id,
                                                        row.subcase
                                                    )
                                                "
                                            >
                                                <v-icon
                                                    large
                                                    dark
                                                    class="btn-menu-9"
                                                    :color="
                                                        row.cso.length == 0
                                                            ? 'grey'
                                                            : 'light-blue darken-2'
                                                    "
                                                >
                                                    mdi-file-image
                                                </v-icon>
                                            </v-avatar>
                                        </v-badge>
                                    </td>

                                    <td class="text-center">
                                        <v-badge
                                            avatar
                                            bordered
                                            overlap
                                            style="margin-top:11px;"
                                            v-if="
                                                row.project_name != 'Return' &&
                                                    row.project_name !=
                                                        'Return-Pickup' &&
                                                    row.show_upload == 'Y'
                                            "
                                        >
                                            <template v-slot:badge>
                                                <v-avatar
                                                    :color="
                                                        row.attach.length == 0
                                                            ? 'grey'
                                                            : 'orange'
                                                    "
                                                >
                                                    {{ row.attach.length }}
                                                </v-avatar>
                                            </template>

                                            <v-avatar
                                                class="
                                                    fix-avatar-per cur-p
                                                "
                                                @click="
                                                    change_img(
                                                        row.attach,
                                                        'attach',
                                                        row.maincase_id,
                                                        row.subcase
                                                    )
                                                "
                                            >
                                                <v-icon
                                                    large
                                                    dark
                                                    class="btn-menu-9"
                                                    :color="
                                                        row.attach.length == 0
                                                            ? 'grey'
                                                            : 'orange'
                                                    "
                                                >
                                                    mdi-file-image
                                                </v-icon>
                                            </v-avatar>
                                        </v-badge>
                                    </td>
                                    <td class="text-center">
                                        <v-badge
                                            avatar
                                            bordered
                                            overlap
                                            style="margin-top:11px;"
                                            v-if="
                                                row.project_name != 'Return' &&
                                                    row.project_name !=
                                                        'Return-Pickup' &&
                                                    row.product_group !=
                                                        'Printing' &&
                                                    row.show_upload == 'Y'
                                            "
                                        >
                                            <template v-slot:badge>
                                                <v-avatar
                                                    :color="
                                                        row.uefi.length == 0
                                                            ? 'grey'
                                                            : 'green accent-4'
                                                    "
                                                >
                                                    {{ row.uefi.length }}
                                                </v-avatar>
                                            </template>

                                            <v-avatar
                                                class="
                                                    fix-avatar-per cur-p
                                                "
                                                @click="
                                                    change_img(
                                                        row.uefi,
                                                        'uefi',
                                                        row.maincase_id,
                                                        row.subcase
                                                    )
                                                "
                                            >
                                                <v-icon
                                                    large
                                                    dark
                                                    class="btn-menu-9"
                                                    :color="
                                                        row.uefi.length == 0
                                                            ? 'grey'
                                                            : 'green accent-4'
                                                    "
                                                >
                                                    mdi-file-image
                                                </v-icon>
                                            </v-avatar>
                                        </v-badge>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                    <hr class="fix-hr-1" />
                </v-col>
            </v-row>
        </div>

        <v-row justify="center">
            <v-dialog
                v-model="dialog"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
            >
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark @click="close_dialog()">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <!-- <v-toolbar-title>Settings</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn dark text @click="dialog = false"
                                >Save</v-btn
                            >
                        </v-toolbar-items> -->
                    </v-toolbar>
                    <v-list three-line subheader>
                        <v-list-item>
                            <v-list-item-content>
                                <v-row>
                                    <v-col cols="12">
                                        <div
                                            id="my-strictly-unique-vue-upload-multiple-image"
                                            style="text-align: center;"
                                        >
                                            <vue-upload-multiple-image
                                                @upload-success="
                                                    uploadImageSuccess
                                                "
                                                @before-remove="beforeRemove"
                                                @edit-image="editImage"
                                                @data-change="dataChange"
                                                dragText="UPLOAD"
                                                browseText="Upload"
                                                primaryText="Upload image"
                                                markIsPrimaryText="จัดลำดับรูปภาพ"
                                                idUpload="myIdUpload"
                                                editUpload="myIdEdit"
                                                :data-images="form.img"
                                                :maxImage="20"
                                            ></vue-upload-multiple-image>
                                        </div>
                                    </v-col>
                                    <v-col cols="12" class="mar-t-20">
                                        <v-btn
                                            color="success"
                                            v-if="this.form.img.length > 0"
                                            @click="save_img()"
                                        >
                                            <v-icon small class="mr-1"
                                                >mdi-content-save</v-icon
                                            >
                                            Save Images
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col
                                        cols="6"
                                        sm="4"
                                        md="3"
                                        lg="2"
                                        v-for="(pic, num_pic) in data_img"
                                        :key="num_pic"
                                    >
                                        <div
                                            class="images"
                                            v-viewer="{ movable: false }"
                                        >
                                            <div>
                                                <img
                                                    :src="url_pic + pic.file_id"
                                                    class="image-cso"
                                                />
                                                <v-btn
                                                    fab
                                                    color="red accent-2"
                                                    class="image-cso-btn"
                                                    x-small
                                                    @click="
                                                        del_img(
                                                            pic.file_id,
                                                            num_pic
                                                        )
                                                    "
                                                >
                                                    <v-icon
                                                        >mdi-delete-forever</v-icon
                                                    >
                                                </v-btn>
                                            </div>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-dialog>
        </v-row>

        <v-row justify="center">
            <v-dialog
                v-model="dialoghistory"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
            >
                <v-card>
                    <v-app-bar fixed dark color="primary" data-v-f3f3eg9>
                        <v-btn icon dark @click="dialoghistory = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title
                            >History

                            <!-- <v-chip class="ml-2" color="white" light dense>
                <strong></strong>
              </v-chip> -->
                        </v-toolbar-title>
                    </v-app-bar>

                    <v-timeline dense class="mt-12 pt-12 pr-12">
                        <v-timeline-item color="teal" fill-dot small>
                            <v-row>
                                <v-col cols="11" sm="5" md="3">
                                    <v-menu
                                        ref="menu1"
                                        v-model="menu"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y
                                        max-width="290px"
                                        min-width="290px"
                                    >
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-text-field
                                                v-model="dateFormatted"
                                                label="Date"
                                                :rules="notdate"
                                                required
                                                persistent-hint
                                                prepend-icon="mdi-calendar-month"
                                                v-bind="attrs"
                                                @blur="
                                                    date = parseDate(
                                                        dateFormatted
                                                    )
                                                "
                                                v-on="on"
                                                outlined
                                                dense
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="date"
                                            no-title
                                            @input="menu = false"
                                        ></v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="11" sm="5" md="3">
                                    <v-select
                                        :items="data_zonehistory"
                                        v-model="form_searchhistory.branch_id"
                                        item-text="branch_name"
                                        item-value="branch_id"
                                        :rules="notzone"
                                        required
                                        outlined
                                        dense
                                        multiple
                                        @change="
                                            get_engineerhistory(),
                                                selectzonefilter()
                                        "
                                    >
                                        <template v-slot:label>
                                            <v-icon
                                                small
                                                class="mb-1"
                                                style="vertical-align: middle"
                                            >
                                                mdi-filter
                                            </v-icon>
                                            Filter Zone
                                        </template>
                                        <template
                                            v-slot:selection="{
                                                item,
                                                index,
                                            }"
                                        >
                                            <v-chip v-if="index === 0">
                                                <span>{{
                                                    item.branch_name
                                                }}</span>
                                            </v-chip>
                                            <span
                                                v-if="index === 1"
                                                class="grey--text caption"
                                                >(+{{
                                                    form_searchhistory.branch_id
                                                        .length - 1
                                                }}
                                                others)</span
                                            >
                                        </template>
                                        <template v-slot:prepend-item>
                                            <v-list-item
                                                ripple
                                                @click="toggle()"
                                            >
                                                <v-list-item-action>
                                                    <v-icon
                                                        :color="
                                                            form_searchhistory
                                                                .branch_id
                                                                .length > 0
                                                                ? 'indigo darken-4'
                                                                : ''
                                                        "
                                                        >{{
                                                            form_searchhistory.icon
                                                        }}</v-icon
                                                    >
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        Select All
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-divider class="mt-2"></v-divider>
                                        </template>
                                    </v-select>
                                </v-col>
                                <v-col cols="11" sm="5" md="3">
                                    <v-select
                                        v-if="
                                            form_searchhistory.engineer &&
                                                form_searchhistory.engineer
                                                    .length > 0
                                        "
                                        class="pr-3"
                                        :items="form_searchhistory.engineer"
                                        v-model="form_searchhistory.emp_id"
                                        item-text="emp_name_en"
                                        item-value="emp_id"
                                        menu-props="auto"
                                        outlined
                                        dense
                                        clearable
                                        @change="get_datahistory()"
                                    >
                                        <template v-slot:label>
                                            <v-icon
                                                small
                                                class="mb-1"
                                                style="vertical-align: middle"
                                            >
                                                mdi-filter
                                            </v-icon>
                                            Filter Engineer
                                        </template>
                                    </v-select></v-col
                                >
                            </v-row>
                            <div
                                v-for="(datamainhistory,
                                idx1) in data_mainhistory"
                                :key="idx1"
                            >
                                <v-row>
                                    <v-col md="12">
                                        <h3
                                            v-if="
                                                datamainhistory.onsite.length >
                                                    0
                                            "
                                        >
                                            {{ datamainhistory.branch_name }} (
                                            {{ datamainhistory.emp_name_en }}
                                            {{ datamainhistory.emp_surname_en }}
                                            ) HPI :
                                            {{
                                                getHPIAmount(
                                                    datamainhistory.onsite
                                                )
                                            }}
                                            Cases | NONHP :
                                            {{
                                                getNONHPAmount(
                                                    datamainhistory.onsite
                                                )
                                            }}
                                            Cases
                                        </h3>
                                        <h3 v-else>
                                            {{ datamainhistory.branch_name }} (
                                            {{ datamainhistory.emp_name_en }}
                                            {{ datamainhistory.emp_surname_en }}
                                            )
                                        </h3>
                                    </v-col>
                                </v-row>

                                <v-simple-table
                                    class="table-inv"
                                    cellpadding="0"
                                    cellspacing="0"
                                >
                                    <thead>
                                        <tr class="col-tr-1">
                                            <th class="text-center white--text">
                                                #
                                            </th>
                                            <th class="text-center white--text">
                                                Case
                                            </th>
                                            <th class="text-center white--text">
                                                Date
                                            </th>
                                            <th class="text-center white--text">
                                                Product
                                            </th>
                                            <th class="text-center white--text">
                                                Site Name
                                            </th>

                                            <th class="text-center white--text">
                                                Ce Log Status
                                            </th>
                                            <th class="text-center white--text">
                                                Remark
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody
                                        v-if="datamainhistory.onsite.length > 0"
                                    >
                                        <tr
                                            v-for="(row,
                                            idx1) in datamainhistory.onsite"
                                            :key="idx1"
                                        >
                                            <td class="text-center">
                                                {{ idx1 + 1 }}.
                                            </td>
                                            <td>
                                                <v-btn
                                                    class="mr-1"
                                                    :to="
                                                        '/Project/ViewCasepending/' +
                                                            team_name +
                                                            '/' +
                                                            row.maincase_id +
                                                            '/ViewDetail'
                                                    "
                                                    target="_blank"
                                                    x-small
                                                    color="white"
                                                    rounded
                                                >
                                                    <span
                                                        :class="
                                                            row.case_id !=
                                                                'return-pickup' &&
                                                            row.case_id !=
                                                                'return'
                                                                ? 'primary--text mr-1'
                                                                : 'green--text mr-1'
                                                        "
                                                        >{{
                                                            row.case_id +
                                                                "-" +
                                                                row.subcase
                                                        }}
                                                    </span>

                                                    <span class="teal--text">
                                                        {{ row.log_date }}</span
                                                    >
                                                </v-btn>
                                                <v-chip
                                                    x-small
                                                    class="amber mt-1"
                                                >
                                                    {{
                                                        row.project_name
                                                    }}</v-chip
                                                >
                                            </td>

                                            <td class="text-center">
                                                <v-chip
                                                    x-small
                                                    v-if="row.open_date"
                                                >
                                                    {{
                                                        "Open : " +
                                                            row.open_date
                                                    }}
                                                </v-chip>
                                                <v-chip
                                                    x-small
                                                    class="mt-1"
                                                    color="primary"
                                                    v-if="row.ship_date"
                                                >
                                                    {{
                                                        "Ship : " +
                                                            row.ship_date
                                                    }}
                                                </v-chip>
                                            </td>
                                            <td>
                                                <v-chip
                                                    x-small
                                                    v-if="row.case_type"
                                                    >{{ row.case_type }}</v-chip
                                                >

                                                <v-chip
                                                    x-small
                                                    class="mt-1"
                                                    color="green lighten-3"
                                                >
                                                    <span
                                                        class="mr-1"
                                                        v-if="row.product_group"
                                                        >{{
                                                            row.product_group
                                                        }}</span
                                                    >
                                                    <span
                                                        v-if="
                                                            row.problem_type_name
                                                        "
                                                        >{{
                                                            row.problem_type_name
                                                        }}</span
                                                    >
                                                </v-chip>
                                            </td>
                                            <td>
                                                {{ row.site_name }}
                                                <br />
                                                <span
                                                    v-if="row.site_amphur_id"
                                                    >{{
                                                        row.site_amphur_id
                                                    }}</span
                                                >
                                                <span
                                                    v-if="row.site_province_id"
                                                    >{{
                                                        row.site_province_id
                                                    }}</span
                                                >
                                            </td>

                                            <td>
                                                {{ row.ce_log_status }}
                                            </td>
                                            <td>
                                                {{ row.remark }}
                                            </td>
                                        </tr>
                                    </tbody>

                                    <tbody v-else>
                                        <tr>
                                            <td colspan="5" align="center">
                                                No Case
                                            </td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </div>
                        </v-timeline-item>
                    </v-timeline>
                </v-card>
            </v-dialog>
        </v-row>

        <v-row justify="center">
            <v-dialog v-model="dialog_solution" persistent max-width="450">
                <v-card>
                    <v-card-title class="headline">
                        Edit Solution
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <v-textarea
                                    outlined
                                    label="Solution.."
                                    background-color="#FFFF"
                                    rows="4"
                                    v-model="data_solution.solution"
                                ></v-textarea>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            color="green darken-1"
                            text
                            @click="close_dialog_solution()"
                        >
                            close
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="success" @click="save_edit_solution()">
                            <v-icon small class="mr-1">mdi-content-save</v-icon>
                            Save
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

        <v-dialog
            v-model="dialog_ismart"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
            <v-card tile>
                <v-toolbar flat dark color="primary">
                    <v-btn icon dark @click="close_view_ismart()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <ISmart
                        :data_ismart="data_ismart"
                        @close_page="close_view_ismart()"
                        :check_page="2"
                    />
                </v-card-text>

                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="dialog_signature"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
            <v-card tile>
                <v-toolbar flat dark color="primary">
                    <v-btn icon dark @click="close_e_cso()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <Signature
                        pages="performance"
                        :e_email="e_email"
                        :data_sign="data_sign"
                        :show_rate="show_rate"
                        :show_sign="show_sign"
                        @page_ismart_perf="page_ismart_perf"
                    />
                </v-card-text>

                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>

        <!-- btn - action -->
        <div id="snackbar" class="d-print-none">
            <v-snackbar v-model="snackbar" color="success" right>
                {{ text }}
            </v-snackbar>
        </div>

        <v-dialog v-model="dialog_loading" hide-overlay persistent width="320">
            <v-card color="primary" dark>
                <v-card-text>
                    <span class="mt-1 white--text">Loading</span>
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import axios from "axios"
import _ from "lodash"
import { mapState, mapMutations } from "vuex"
import VueUploadMultipleImage from "vue-upload-multiple-image"
import ISmart from "./ISmart.vue"
import Signature from "./Signature.vue"

const url = `${process.env.VUE_APP_ROOT_API}/api/`

export default {
    watch: {
        date(val) {
            this.dateFormatted = this.formatDate(this.date)
            this.get_datahistory()
        },
    },
    components: {
        VueUploadMultipleImage,
        ISmart,
        Signature,
    },
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        this.get_data()
        this.get_zone()
        this.get_summary()
    },
    created() {
        this.get_data = _.debounce(this.get_data, 300)
    },
    computed: {
        dateRangeText() {
            this.dates.sort((a, b) => {
                return new Date(a) - new Date(b)
            })

            return this.dates.join(" ~ ")
        },
        ...mapState(["isLoading"]),
        ...mapState(["snackbar"]),
    },
    methods: {
        ...mapMutations(["mutateIsLoading"]),
        ...mapMutations(["mutatesnackbar"]),
        getHPIAmount(cases) {
            let filter = cases.filter((each) => {
                // console.log(each.project_name)
                return (
                    each.project_name == "CDAX" ||
                    each.project_name == "S-Print" ||
                    each.project_name == "SRFR"
                )
            })
            // console.log(filter)
            return filter.length
        },
        getNONHPAmount(cases) {
            let filter = cases.filter((each) => {
                // console.log(each.project_name)
                return (
                    each.project_name != "CDAX" &&
                    each.project_name != "S-Print" &&
                    each.project_name != "SRFR"
                )
            })
            // console.log(filter)
            return filter.length
        },
        selectzonefilter() {
            if (
                this.form_searchhistory.branch_id.length ===
                this.data_zonehistory.length
            ) {
                this.form_searchhistory.icon = "mdi-close-box"
            }
        },
        toggle() {
            if (
                this.form_searchhistory.branch_id.length !==
                this.data_zonehistory.length
            ) {
                this.form_searchhistory.icon = "mdi-close-box"
                this.form_searchhistory.branch_id = []
                for (let a = 0; a < this.data_zonehistory.length; a++) {
                    this.form_searchhistory.branch_id.push(
                        this.data_zonehistory[a].branch_id
                    )

                    this.form_searchhistory.engineer = []
                }
            } else {
                this.form_searchhistory.icon = "mdi-checkbox-blank-outline"
                this.form_searchhistory.branch_id = []
                this.form_searchhistory.engineer = []
            }
            setTimeout(() => {
                this.get_engineerhistory()
            }, 1000)
        },
        toggledefault() {
            this.form_searchhistory.icon = "mdi-close-box"
            this.form_searchhistory.branch_id = []
            for (let a = 0; a < this.data_zonehistory.length; a++) {
                this.form_searchhistory.branch_id.push(
                    this.data_zonehistory[a].branch_id
                )
                this.form_searchhistory.engineer = []
            }
        },
        async get_engineerhistory() {
            this.form_searchhistory.emp_id = ""
            this.form_searchhistory.engineer = []
            // this.show_page = 1;
            // this.get_data(1);
            // this.get_summary(this.form_search.branch_id, "all");
            // this.data_main = [];

            if (this.form_searchhistory.branch_id.length == 1) {
                await axios
                    .get(
                        url +
                            "ce-update/get-ce/" +
                            this.form_searchhistory.branch_id,
                        this.tk
                    )
                    .then((response) => {
                        this.form_searchhistory.engineer =
                            response.data.engineer
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            }

            this.get_datahistory()
        },
        async get_zonehistory(test) {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            let url = `${process.env.VUE_APP_ROOT_API}/api/ce-update/get-zone`
            await axios.get(url, options).then((response) => {
                this.data_zonehistory = response.data.zone
            })
            if (test !== undefined) {
                this.toggledefault()
            }
            this.get_datahistory()
        },
        async get_datahistory() {
            this.data_mainhistory = []
            if (
                this.form_searchhistory.branch_id != "" &&
                this.form_searchhistory.branch_id != undefined
            ) {
                this.dialog_loading = true
                await axios
                    .post(
                        url + "ce-update/view-history",
                        {
                            date: this.date,
                            branch_id: this.form_searchhistory.branch_id,
                            engineer: this.form_searchhistory.emp_id,
                        },
                        this.tk
                    )
                    .then((response) => {
                        console.log(response.data, "history")
                        this.data_mainhistory = response.data
                        this.dialog_loading = false
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            }
        },
        formatDate(date) {
            if (!date) return null

            const [year, month, day] = date.split("-")
            return `${year}-${month}-${day}`
        },
        parseDate(date) {
            if (!date) return null

            const [month, day, year] = date.split("/")
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`
        },
        async get_data() {
            this.mutateIsLoading()
            let date = {
                date: this.dates,
            }
            await axios
                .post(url + "engineer/performance", date, this.tk)
                .then((response) => {
                    // console.log(response, "-engineer/performance")
                    this.data_main = response.data

                    this.mutateIsLoading()
                })
                .catch(function(error) {
                    console.log(error)
                })
        },
        get_date() {
            if (this.dateRangeText.length === 23) {
                this.get_data()
                this.menu2 = false
            }
        },
        // reset() {
        //     this.dates = []
        //     this.data_main = []
        // },
        change_img(img, names, maincase_id, subcase) {
            this.form.maincase_id = maincase_id
            this.form.subcase = subcase
            this.active_img = names
            this.data_img = img
            this.dialog = true
        },
        close_dialog() {
            this.active_img = null
            this.form.img = []
            // this.form = {
            //     maincase_id: null,
            //     subcase: null,
            //     img: [],
            // }
            this.data_img = []
            this.get_data()
            this.dialog = false
        },
        uploadImageSuccess(formData, index, fileList) {
            this.form.img = fileList
        },
        beforeRemove(index, done, fileList) {
            var r = confirm("remove image")
            if (r == true) {
                done()
            } else {
            }
        },
        editImage(formData, index, fileList) {},
        dataChange() {},
        del_img(id, num_pic) {
            this.$swal({
                title: "ต้องการลบรูป " + this.active_img + " ใช้หรือไม่",
                text: "",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then((del) => {
                if (del) {
                    axios
                        .delete(url + "case/attachments/" + id)
                        .then((response) => {
                            this.data_img = this.data_img.filter(
                                (item) => item !== this.data_img[num_pic]
                            )
                        })
                        .catch((error) => {
                            console.log(error)
                        })
                }
            })
        },
        async save_img() {
            this.mutateIsLoading()
            let formData = new FormData()
            formData.append("maincase_id", this.form.maincase_id)
            formData.append("subcase", this.form.subcase)
            for (let i = 0; i < this.form.img.length; i++) {
                formData.append(
                    this.active_img + `[${i}]`,
                    this.form.img[i].path
                )
            }
            //Save Img
            await axios
                .post(url + "engineer/upload-more", formData, this.tk)
                .then((response) => {
                    this.mutateIsLoading()
                    this.get_data()
                    this.close_dialog(0)
                })
                .catch(function(error) {
                    console.log(error, "-- upload img error")
                })
        },
        change_solotion(data) {
            this.data_solution.solution = data.solution
            this.data_solution.subcase_id = data.subcase_id
            this.dialog_solution = true
        },
        close_dialog_solution() {
            this.data_solution.solution = ""
            this.data_solution.subcase_id = ""
            this.dialog_solution = false
        },
        async save_edit_solution() {
            await axios
                .post(
                    url + "engineer/edit-solution",
                    this.data_solution,
                    this.tk
                )
                .then((response) => {
                    this.mutatesnackbar()
                    this.get_data()
                    this.close_dialog_solution()
                    if (this.snackbar === true) {
                        setTimeout(() => {
                            this.mutatesnackbar()
                        }, 3000)
                    }
                })
                .catch(function(error) {
                    console.log(error)
                })
        },
        view_ismart(subcase_id) {
            this.data_ismart = subcase_id
            this.dialog_ismart = true
        },
        close_view_ismart(subcase_id) {
            this.data_ismart = ""
            this.dialog_ismart = false
        },
        view_e_cso(subcase_id, show_ratex, show_signx, e_email) {
            // console.log(show_ratex, "-show_ratex")
            // console.log(show_signx, "-show_signx")
            this.show_rate = show_ratex == "Y" ? true : false
            this.show_sign = show_signx == "Y" ? true : false
            this.data_sign = subcase_id
            this.e_email = e_email
            this.dialog_signature = true
        },
        page_ismart_perf() {
            this.get_data()
            this.close_e_cso()
        },
        close_e_cso() {
            this.data_sign = false
            this.show_rate = false
            this.show_sign = ""
            this.e_email = ""
            this.dialog_signature = false
        },
    },
    data() {
        return {
            show_rate: false,
            show_sign: false,
            e_email: "",
            data_sign: "",
            dialog_signature: false,
            dialog_ismart: false,
            data_ismart: "",
            dialog_solution: false,
            data_solution: {
                solution: "",
                subcase_id: "",
            },
            active_img: null,
            dialog: false,
            data_img: [],
            data_main: [],
            dates: [
                new Date().toISOString().substr(0, 10),
                new Date().toISOString().substr(0, 10),
            ],
            form: {
                maincase_id: null,
                subcase: null,
                img: [],
            },
            tk: null,
            menu2: false,
            url_pic: `${process.env.VUE_APP_ROOT_API}/api/case/attachments/`,

            // qtest
            notdate: [(v) => v.length > 0 || "Date is required"],
            notzone: [(v) => v.length > 0 || "Zone is required"],
            form_searchhistory: {
                branch_id: [],
                zone: [],
                engineer: [],
                emp_id: "",
                icon: "mdi-checkbox-blank-outline",
            },

            data_mainhistory: [],
            data_zonehistory: [],
            date: new Date().toISOString().substr(0, 10),
            dateFormatted: new Date().toISOString().substr(0, 10),
            menu1: false,
            menu2: false,
            menu: false,
            // dates: [
            //   new Date().toISOString().substr(0, 10),
            //   new Date().toISOString().substr(0, 10),
            // ],
            dialoghistory: false,
            team_name: localStorage.team_name,
            show_page: 1,
            data_case: [],
            data_zone: [],
            form_search: {
                branch_id: 0,
                zone: [],
                engineer: [],
                emp_id: "",
            },
            text: "Success, Your work has been saved",
        }
    },
}
</script>
<style scoped>
/* .fix-avatar-per {
    border-radius: 30% !important;
    height: 35px !important;
    width: 35px !important;
    background: linear-gradient(
        to bottom right,
        rgb(40, 79, 151),
        rgb(10, 138, 116)
    );
} */
.image-cso {
    height: 100px;
    cursor: pointer;
    margin: 5px;
    display: inline-block;
}
.image-cso-btn {
    margin-top: -10px !important;
    margin-left: -18px !important;
}
</style>
